import React from 'react';

const CrossLabel = () => (
 <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.808942 1.61705C0.493007 1.30112 0.493007 0.788885 0.808942 0.472951C1.12488 0.157017 1.63711 0.157017 1.95304 0.472951L10.28 8.7999L18.6069 0.472951C18.9229 0.157017 19.4351 0.157017 19.751 0.472951C20.067 0.788885 20.067 1.30112 19.751 1.61705L11.4241 9.944L19.751 18.271C20.067 18.5869 20.067 19.0991 19.751 19.4151C19.4351 19.731 18.9229 19.731 18.6069 19.4151L10.28 11.0881L1.95304 19.4151C1.63711 19.731 1.12488 19.731 0.808943 19.4151C0.493008 19.0991 0.493008 18.5869 0.808943 18.271L9.13589 9.944L0.808942 1.61705Z" fill="#141414"/>
</svg>
);

export default CrossLabel;
